import { IEnv } from '../app/core/interface/app-interface';

export const environment: IEnv = {
  loggingEnabled: true,
  production: true,
  name: 'development',
  local: true,
  baseUrl: 'https://tsc-api-dev.connecit.net/api/',
  visibility: 'toyo',
};
